import React, { Suspense, lazy, useState, useEffect } from 'react';
import './css/loading.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const Home = lazy(() => import('./views/dashboard/login.js'));
const PolicyPage = lazy(() => import('./views/dashboard/policy.js'));
const PolicyParkPage = lazy(() => import('./views/dashboard/park.js'));
const ParkListPolicy = lazy(() => import('./views/dashboard/parklistpolicy.js'));
const NavBlock = lazy(() => import('./components/nav.js'));
const Logout = lazy(() => import('./components/logout.js'));




function App() {
    const [dopPage, setDopPage] = useState([])
    useEffect(() => {
       let q = JSON.parse(localStorage.getItem("dopPages"));
       if (q && Array.isArray(q)){
        setDopPage(q)
       }
    }, []);  

    
    
    return (
        <Router>
            <Suspense fallback={<div className='loading-page'>Загрузка...</div>}>
                <Routes >
                    <Route path="" element={<Home />} />
                    <Route path="/logout" element={<Logout />} /> 
                    <Route path="/" element={<NavBlock />}>
                        <Route path="policy" element={ <PolicyPage />} />
                        <Route path="policypark/:id" element={ <ParkListPolicy />} />
                        <Route path="policypark" element={ <PolicyParkPage />} />
                        <Route path="*" element={<PolicyPage />} />
                    </Route>
                </Routes>
            </Suspense>
        </Router>
    );
}

export default App;
